// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"fc9c2db3","551":"3a43b8bd","849":"55c40661"}[chunkId] + ".chunk.js";
};